/**
 * @fileOverview A simple function to create a new icon using a SVG sprite.
 * @author Selectra Front End Team
 * @version 1.0.0
 * @requires Polyfill:classlist
 */


/**
 * @function createIcon
 * @description Creates a nes svg icon.
 * @arg {String} iconID - The ID string of the DS icon.
 * @arg {Array} [iconClasses] - An array of class names to be added to the new
 *     SVG element.
 * @arg {String} [spritePath='/img/sprite.svg'] - The path for the sprite file.
 * @returns {Element} A SVG element for the new icon.
 */
export default function createIcon(
  iconID,
  iconClasses = [],
  spritePath = '/img/sprite.svg' ) {

  const
    svg = document.createElementNS( 'http://www.w3.org/2000/svg', 'svg' ),
    use = document.createElementNS( 'http://www.w3.org/2000/svg', 'use' ),
    iconURL = `${ spritePath }#${ iconID }`;

  svg.classList.add( 'icon', ...iconClasses );
  svg.setAttribute( 'aria-hidden', 'true' );
  use.setAttributeNS( 'http://www.w3.org/1999/xlink', 'href', iconURL );
  svg.appendChild( use );

  return svg;

}
